import { useEffect, useState } from 'react';

function useEyeTracking(enabled) {
  const [offset, setOffset] = useState({ x: 0, y: 0 });
  useEffect(() => {
    if (!enabled) return;
    if (typeof window === 'undefined') return;
    if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    function onMove(e) {
      const cx = window.innerWidth / 2;
      const cy = window.innerHeight / 2;
      const dx = (e.clientX - cx) / window.innerWidth;
      const dy = (e.clientY - cy) / window.innerHeight;
      setOffset({ x: dx * 3, y: dy * 2 });
    }
    window.addEventListener('mousemove', onMove);
    return () => window.removeEventListener('mousemove', onMove);
  }, [enabled]);
  return offset;
}

export default function Smiley({
  size = 100,
  variant = 'default',
  tracking = false,
  bobble = false,
  heartPulse = false,
  expression = 'smile',
}) {
  const fill = variant === 'knockout' ? 'transparent' : '#FFCD2E';
  const strokeColor = variant === 'knockout' ? '#F6F1E6' : '#0E0E10';
  const eyeFill = variant === 'knockout' ? '#F6F1E6' : '#0E0E10';
  const offset = useEyeTracking(tracking);
  const cls = ['smy-svg', bobble ? 'is-bobble' : '', expression === 'tilted' ? 'is-tilted' : '']
    .filter(Boolean)
    .join(' ');
  const mouth = expression === 'tilted'
    ? <path d="M30 68 Q50 58 72 68" stroke={eyeFill} strokeWidth="6" fill="none" strokeLinecap="round" />
    : <path d="M28 60 Q50 82 72 60" stroke={eyeFill} strokeWidth="6" fill="none" strokeLinecap="round" />;
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} aria-hidden="true" className={cls} style={{ flexShrink: 0, maxWidth: '100%', height: 'auto' }}>
      <circle cx="50" cy="50" r="46" fill={fill} stroke={strokeColor} strokeWidth="5" />
      <circle cx={34 + offset.x} cy={42 + offset.y} r="6.5" fill={eyeFill} />
      {expression === 'tilted' ? (
        <g stroke={eyeFill} strokeWidth="5" strokeLinecap="round">
          <line x1="62" y1="36" x2="74" y2="48" />
          <line x1="74" y1="36" x2="62" y2="48" />
        </g>
      ) : (
        <path className={heartPulse ? 'heart-eye' : ''} d="M68 38 C65.5 36 62 37 62 41 C62 45 68 49 68 49 C68 49 74 45 74 41 C74 37 70.5 36 68 38 Z" fill={eyeFill} />
      )}
      {mouth}
    </svg>
  );
}
